import {Badge} from './badge.component'

export * from './badge.component';

export default Badge;

customElements.define('wl-badge', Badge);